import React, { useEffect, useState } from "react";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Tag } from "primereact/tag";
import { IPurchaseOrder, POStatus } from "../../models/PurchaseOrder";
import { ILogin } from "../../models/Login";
import { Fetch } from "../../shared/Fetch";

interface Props {
  po: IPurchaseOrder;
  toast: any;
  onSave?: () => void;
  onCancel?: () => void;
}

const RateChangeForBandS = ({ po, toast, onSave, onCancel }: Props) => {
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const roles: number[] = loginObj.roles.map((r) => r.role_ID);
  const canEditBRate = roles.includes(3) || roles.includes(4) || roles.includes(21);
  const canEditSRate = roles.includes(2) || roles.includes(5);
  const [originalRates] = useState({
    bRate: po?.bRate ?? 0,
    sRate: po?.sRate ?? 0,
    mRate: po?.mRate ?? 0,
  });

  const [bRate, setBRate] = useState<number>(po?.bRate ?? 0);
  const [sRate, setSRate] = useState<number>(po?.sRate ?? 0);
  const [loading, setLoading] = useState(false);
  const margin = sRate - bRate;
  useEffect(() => {
    setBRate(po?.bRate ?? 0);
    setSRate(po?.sRate ?? 0);
  }, [po?.pO_ID]);

  const handleSave = async () => {
    if (canEditBRate && !canEditSRate) {
      if (bRate === originalRates.bRate) {
        // toast?.current?.show({ severity: "warn", content: `Please change Buying Rate It is same as original rate ${originalRates.bRate}` });
        toast?.current?.show({
          severity: "warn",
          content: (
            <span>
              Please change <span style={{ color: "black" }}>Buying Rate</span> It is same as original rate :-<span style={{ color: "#ff4d4f", fontWeight: 600 }}>{originalRates.bRate}</span>
            </span>
          ),
        });
        return;
      }
    }

    if (!canEditBRate && canEditSRate) {
      if (sRate === originalRates.sRate) {
        // toast?.current?.show({ severity: "warn", content: `Please change Submission Rate It is same as original rate ${originalRates.sRate}` });
        toast?.current?.show({
          severity: "warn",
          content: (
            <span>
              Please change <span style={{ color: "black" }}>Submission Rate</span> It is same as original rate :-<span style={{ color: "#ff4d4f", fontWeight: 600 }}>{originalRates.sRate}</span>
            </span>
          ),
        });
        return;
      }
    }

    if (bRate > sRate) {
      toast?.current?.show({ severity: "error", content: "Buying Rate cannot be greater than Submission Rate" });
      return;
    }

    setLoading(true);

    const response = await Fetch(
      "Po_Rate_Change/rateChangeRequest",
      "POST",
      {
        pO_ID: po.pO_ID,
        p_BRate: Number(originalRates.bRate),
        p_SRate: Number(originalRates.sRate),
        p_MRate: Number(originalRates.mRate),
        r_BRate: Number(bRate),
        r_SRate: Number(sRate),
        r_MRate: Number(margin),
      },
      null,
      toast,
    );
    setLoading(false);

    if (response) {
      const resp: any = await response.json();
      if (resp.message !== undefined && resp.message !== null && resp.message.trim() !== "") {
        toast?.current?.show({ severity: "success", content: resp.message });
      } else
        toast?.current?.show({ severity: "success", content: "Rate change request submitted. Pending admin approval." });
      onSave?.();
    }
  };

  return (
    <div className="p-fluid">
      <div className="flex align-items-center gap-3 mb-4 p-3 border-round surface-100">
        <i className="pi pi-file text-primary text-xl" />
        <div>
          <div className="font-semibold text-900">{po?.consultant_Name ?? "—"}</div>
          <div className="text-sm text-color-secondary">{po?.company_Name_Sales ?? "—"}</div>
        </div>
        <Tag className="ml-auto" value={po?.pO_Status ? POStatus[po.pO_Status] : "—"} severity={po?.pO_Status === POStatus.Joined ? "success" : "warning"} />
      </div>
      <div className="surface-50 border-round p-3 mb-4 border-1 border-200">
        <div className="text-sm text-color-secondary mb-2 font-medium">Current Rates (before change)</div>
        <div className="flex gap-4">
          <span className="text-sm">
            B Rate: <strong>{originalRates.bRate}</strong>
          </span>
          <span className="text-sm">
            S Rate: <strong>{originalRates.sRate}</strong>
          </span>
          <span className="text-sm">
            Margin: <strong>{originalRates.mRate}</strong>
          </span>
        </div>
      </div>

      <div className="grid">
        <div className="col-12 md:col-4">
          <div className="flex flex-column gap-2">
            <label className="font-medium text-sm text-color-secondary flex align-items-center gap-2">
              B Rate
              {canEditBRate ? (
                <span className="text-xs text-green-600">
                  <i className="pi pi-pencil mr-1" />
                  editable
                </span>
              ) : (
                <span className="text-xs text-color-secondary">
                  <i className="pi pi-lock mr-1" />
                  view only
                </span>
              )}
            </label>
            <InputNumber value={bRate} disabled={!canEditBRate} onValueChange={(e) => setBRate(e.value ?? 0)} mode="decimal" minFractionDigits={2} maxFractionDigits={2} />
          </div>
        </div>

        <div className="col-12 md:col-4">
          <div className="flex flex-column gap-2">
            <label className="font-medium text-sm text-color-secondary flex align-items-center gap-2">
              S Rate
              {canEditSRate ? (
                <span className="text-xs text-green-600">
                  <i className="pi pi-pencil mr-1" />
                  editable
                </span>
              ) : (
                <span className="text-xs text-color-secondary">
                  <i className="pi pi-lock mr-1" />
                  view only
                </span>
              )}
            </label>
            <InputNumber value={sRate} disabled={!canEditSRate} onValueChange={(e) => setSRate(e.value ?? 0)} mode="decimal" minFractionDigits={2} maxFractionDigits={2} />
          </div>
        </div>

        <div className="col-12 md:col-4">
          <div className="flex flex-column gap-2">
            <label className="font-medium text-sm text-color-secondary flex align-items-center gap-2">
              Margin
              <span className="text-xs text-color-secondary">
                <i className="pi pi-calculator mr-1" />S − B
              </span>
            </label>
            <InputNumber value={margin} disabled mode="decimal" minFractionDigits={2} maxFractionDigits={2} inputClassName={margin < 0 ? "text-red-500 font-bold" : "text-green-600 font-bold"} />
          </div>
        </div>
      </div>

      <Divider />

      <div className="flex justify-content-end gap-2">
        <Button label="Cancel" icon="pi pi-times" className="p-button-text p-button-secondary" onClick={onCancel} disabled={loading} />
        <Button label="Submit Rate Change Request" icon="pi pi-send" loading={loading} disabled={!canEditBRate && !canEditSRate} onClick={handleSave} />
      </div>
    </div>
  );
};

export default RateChangeForBandS;
